<template>
  <div class="contents permission-serrings">
    <h2>ロール＆アクセス権設定画面</h2>

    <div class="container">
      <div class="roles">
        <h3>ロール一覧</h3>
        <loading v-if="!roles" :message="'ロール一覧の読み込み中'"></loading>
        <p v-else-if="roles && roles.length < 1">表示可能なロールがありません。</p>
        <template v-else>
          <select v-model="selectedRoleId" @change="changeRole">
            <option v-for="role in roles" :value="role.mst_role_id" :selected="role.mst_role_id === selectedRoleId">{{
              role.role_name }}
            </option>
          </select>
        </template>
      </div>

      <loading v-if="selectedRoleId && !permissions || isChanging" :message="'権限一覧の読み込み中'"></loading>
      <p v-else-if="roles && roles.length < 1">表示可能な権限がありません。</p>
      <div v-else-if="permissions && permissions.length > 0" class="permission-list">
        <h3>選択されたロールの権限一覧</h3>
        <scroll-table>
          <table class="permission-table">
            <tr>
              <th>権限名</th>
              <th>実行可否</th>
            </tr>
            <tr v-for="(perm, index) in permissions">
              <td class="name">{{ perm.permission_name }}</td>
              <td class="status">
                <input :disabled="isSaving" type="checkbox" name="" id="" :checked="hasPermission(perm)" @change="switchPermission(perm)">
              </td>
            </tr>
          </table>
        </scroll-table>
        <div class="buttons status-select">
          <button :disabled="isSaving" type="button" class="btn success" v-on:click="savePermissionForRole(selectedRoleId)"><i
              class="fa-solid fa-check"></i>保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, Ref } from 'vue'
import OptionConst from '@/const/Option';
import { usePermissionRoles } from '@/composable/permission_roles/permission_roles';
export default defineComponent({
  setup() {
    const { isSaving, getRoleAndPermissionOptions, getPermissionsByRoleId, roles, permissions, selectedRolePermissions, savePermissionForRole, hasPermission, switchPermission } = usePermissionRoles()
    let selectedRoleId: Ref<number | null> = ref(null)
    let isChanging: Ref<boolean> = ref(false)

    onMounted(async () => {
      await getRoleAndPermissionOptions()
      if (roles.value && roles.value.length > 0) {
        selectedRoleId.value = 1
        await getPermissionsByRoleId(selectedRoleId.value)
      }
    })

    const changeRole = async () => {
      if (!selectedRoleId.value) {
        return
      }
      isChanging.value = true
      await getPermissionsByRoleId(selectedRoleId.value)
      isChanging.value = false
    }

    return {
      OptionConst,
      roles,
      permissions,
      selectedRolePermissions,
      hasPermission,
      switchPermission,
      savePermissionForRole,
      selectedRoleId,
      changeRole,
      isChanging,
      isSaving
    }
  }
})
</script>


<style lang="scss" scoped>
@import '@scss/components/permission-roles-setting.scss';
</style>